"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M22 10.5v2h-4.35c2.22 4.41-.64 9.5-5.65 9.5-3.55 0-6.55-2.46-6.53-6.5h3.02c-.03.18-.05.37-.05.56 0 1.97 1.59 3.56 3.56 3.56s3.56-1.59 3.56-3.56S13.97 12.5 12 12.5H2v-2h20zM8.44 6.94c0-1.97 1.59-3.56 3.56-3.56s3.56 1.59 3.56 3.56c0 .19-.02.38-.05.56h3.02C18.55 3.46 15.55 1 12 1 8.12 1 5.54 4.07 5.6 7.5h2.89a3.43 3.43 0 01-.05-.56z" }), "StrikeThrough");
//# sourceMappingURL=StrikeThrough.js.map